import { render, staticRenderFns } from "./GLCodeMappingPolicyNew.vue?vue&type=template&id=42200976"
import script from "./GLCodeMappingPolicyNew.vue?vue&type=script&lang=js"
export * from "./GLCodeMappingPolicyNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports